import React from 'react';
import { NavLink } from 'react-router-dom';
import { HomeIcon, HeartIcon, ShoppingBagIcon, UserIcon } from '@heroicons/react/24/outline';
import { useCart } from '../context/CartContext';
import { useFavorites } from '../context/FavoritesContext';

function BottomNavBar() {
  const { cartItemCount } = useCart();
  const { favoritesCount } = useFavorites();

  const navItems = [
    { path: '/', icon: HomeIcon, label: 'Ana Sayfa' },
    { path: '/favorites', icon: HeartIcon, label: 'Favoriler', count: favoritesCount },
    { path: '/cart', icon: ShoppingBagIcon, label: 'Sepetim', count: cartItemCount },
    { path: '/my-account', icon: UserIcon, label: 'Hesabım' }
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-t-md z-50">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center w-full text-xs transition-colors ${
                isActive ? 'text-brand-green' : 'text-gray-500 hover:text-brand-green-light'
              }`
            }
          >
            <div className="relative">
              <item.icon className="w-6 h-6" strokeWidth={2} />
              {item.count > 0 && (
                <span className="absolute -top-2 -right-3 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {item.count}
                </span>
              )}
            </div>
            <span className="mt-1">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export default BottomNavBar;